import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import NewsCard from "@/components/NewsCard";
import Section from "@/components/Section";
import Reveal from "@/components/Reveal";
import { getLatestNews } from "@/data/newsData";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/useLanguage";

const LatestNews = () => {
  const { t } = useTranslation();
  const { localize } = useLanguage();
  const latestArticles = getLatestNews(3);

  return (
    <Section
      surface="alt"
      title={
        <>
          {t("latestNews.titlePre")}{" "}
          <span>{t("latestNews.titleAccent")}</span>
        </>
      }
      containerSize="wide"
      grid
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-12">
        {latestArticles.map((article, index) => (
          <Reveal key={article.id} delay={index * 120}>
            <NewsCard article={article} showExcerpt={false} className="bg-background/90" />
          </Reveal>
        ))}
      </div>

      <Reveal className="text-center" delay={150}>
        <Button variant="secondary" size="lg" asChild>
          <Link to={localize("/news")}>{t("latestNews.viewAll")}</Link>
        </Button>
      </Reveal>
    </Section>
  );
};

export default LatestNews;
